<script>

    export let model_root;

    let name = "";
    let prename = "";
    let mail = "";

    let errorMsg = "";
    let successMsg = "";

    function createUser() {
        const data = new FormData();
        data.append("name", name);
        data.append("prename", prename);
        data.append("mail", mail);

        fetch(model_root + 'admin/user_management/new_user.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    showSuccessMsg("Der Nutzer wurde erstellt und hat einen Link zur Registrierung erhalten.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(() => {location.reload()}, 3200);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
    }

</script>

<form class="mt-2 mb-1"
      on:submit|preventDefault={ () => createUser() }>

    <p>Nutzer anlegen: </p>

    <div class="row">
        <div class="col">
            <label class="mr-sm-2" for="prename">Vorname:</label>
            <input type="text" class="form-control" id="prename" placeholder="Vorname" bind:value={prename}>
        </div>
        <div class="col">
            <label class="mr-sm-2" for="name">Nachname:</label>
            <input type="text" class="form-control" id="name" placeholder="Nachname" bind:value={name}>
        </div>
    </div>
    <div class="row">
        <label class="mr-sm-2" for="mail">E-Mail Adresse:</label>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">@</span>
            </div>
            <input type="text" class="form-control" placeholder="E-Mail Adresse" id="mail" bind:value={mail}>
        </div>
    </div>

    {#if errorMsg.length > 0}
        <div class="alert alert-danger" role="alert">
            {errorMsg}
        </div>
    {/if}
    {#if successMsg.length > 0}
        <div class="alert alert-success" role="alert">
            <i class="fas fa-circle-notch fa-spin"></i>
            {successMsg}
        </div>
    {/if}

    <button class="btn btn-primary" type="submit">Registrierungslink zusenden</button>
</form>
